var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"editor",staticClass:"quill-editor mb-16 mt-2 bg-white",staticStyle:{"height":"500px"},attrs:{"options":_vm.editor.options},on:{"change":function (ref) {
	var quill = ref.quill;
	var html = ref.html;
	var text = ref.text;

	return _vm.$emit('change', html);
}},model:{value:(_vm.editor.data),callback:function ($$v) {_vm.$set(_vm.editor, "data", $$v)},expression:"editor.data"}})}
var staticRenderFns = []

export { render, staticRenderFns }